import BaseTbody from "../../../../../commonComponents/fileTbodys/baseFileTbody";
import { ExpendTextAreaByProps } from "../../../../../../base/basicComponents/input";
import ViewNoteHyperLinkModal from "../../../../../../base/basicComponents/viewNoteHyperLinkModal";

export default class CreateProcedureFileTbody extends BaseTbody {
  returnInput = (
    rowColumn: any,
    column: any,
    rowIndex: any,
    procedureNoteMaxLength: any,
    fileSectionDisabled: any
  ) => {
    const fieldDisabled = fileSectionDisabled || column.isDisabled;
    return (
      <>
        {rowColumn.name === "note" && fieldDisabled ? (
          <ViewNoteHyperLinkModal value={rowColumn.value} />
        ) : (
          <ExpendTextAreaByProps
            value={rowColumn.value}
            onChange={(ele: any) => this.props.inputOnChange(ele.target)}
            maxLength={procedureNoteMaxLength}
            disabled={fieldDisabled}
            dataname={column.dataName}
            rowindex={rowIndex}
            style={{
              display: column.isShow ? "table-cell" : "none",
            }}
            ref={column.ref}
            readOnly={rowColumn.readOnly}
            handleTableChange={this.props.handleChangeTableHeight}
            isExpendData={this.props.isExpendData}
            setIsExpendNote={this.props.setIsExpendNote}
          />
        )}
      </>
    );
  };
}
